import { useVuexState } from '@scfe-common/micro-frontend-utils';
import { l as lodashExports } from '../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/lodash.js';

var validatePath = function (path) {
    if (path.startsWith('.') || path.endsWith('.')) {
        throw new Error('Invalid path format. Path should not start or end with a dot (".").');
    }
};
/**
 * Custom hook for dynamically handling enums based on store state.
 * It allows selective retrieval and transformation of enum values based on inclusion or exclusion criteria.
 *
 * @param params.path - The base path:enums.systemEnums.xx
 * @param params.customPath - Optional custom path to override the default state path.
 * @param params.includeType - Optional array of keys to include from the enums.
 * @param params.excludeType - Optional array of keys to exclude from the enums.
 *
 * @returns An object containing:
 *   - enums: The filtered enums based on include and exclude criteria.
 *   - mapping: An object with keys and values inverted from the filtered enums.
 *   - options: An array of objects suitable for dropdowns, each containing a label and a value.
 */
var useDynamicEnums = function (_a, selector) {
    var path = _a.path, customPath = _a.customPath, includeType = _a.includeType, excludeType = _a.excludeType;
    if ((path && customPath) || (!path && !customPath)) {
        throw new Error('Exactly one of "path" or "customPath" must be provided.');
    }
    // Validate the provided path
    var effectivePath = path || customPath;
    validatePath(effectivePath);
    var enumPath = customPath || "enums.systemEnums.".concat(path);
    var originEnums = useVuexState(enumPath) || {};
    var filteredEnum = includeType ? lodashExports.pick(originEnums, includeType) : originEnums;
    filteredEnum = excludeType ? lodashExports.omit(filteredEnum, excludeType) : filteredEnum;
    // Apply the selector if provided
    var finalEnums = selector ? selector(filteredEnum) : filteredEnum;
    var options = Object.keys(finalEnums).map(function (key) { return ({
        label: key,
        value: finalEnums[key],
    }); });
    var mapping = lodashExports.invert(finalEnums);
    return {
        enums: finalEnums,
        mapping: mapping,
        options: options,
    };
};

export { useDynamicEnums as default };
